// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HeartTwoToneSvg from "@fishx/icons-svg/es/asn/HeartTwoTone";
import FishxIcon from '../components/FishxIcon';

var HeartTwoTone = function HeartTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HeartTwoToneSvg
  }));
};

HeartTwoTone.displayName = 'HeartTwoTone';
export default React.forwardRef(HeartTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HeartTwoTone.js
// module id = 2915
// module chunks = 0